import * as React from "react";
import {useState} from "react";
import "./tab3.scss";
import SingleSelectDropzone from "../../../../../../../../ui/dropzone/singleselect/singleSelectDropzone";
import Button from "../../../../../../../../core/button/button";
import Popup from "../../../../../../../../ui/popup/popup";
import Toggle from "../../../../../../../../ui/toggle/toggle";
import DropDown from "../../../../../../../../ui/dropdown/dropdown";
import {DropDownItem} from "../../../../../../../../modals/types/dropdown";
import Comment from "../../../../../../../../ui/comment/comment";

const Tab3 = () => {
    const [openPopup, setOpenPopup] = useState(false);
    const [checked, setChecked] = useState(false);
    const [showContent, setShowContent] = useState(checked);
    const templateDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    const utmContentDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    const utmTermDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    return (
        <div className="Tab3">
            <Popup title={"مدیریت utm لینک"} open={openPopup} setOpen={setOpenPopup} close={() => {
                setOpenPopup(false)
            }}>
                <div className="row">
                    <Toggle label={"فعال سازی utm"} checked={checked} onClick={() => setShowContent(!showContent)}/>
                    {
                        showContent ?
                            <>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">نوع تمپلیت</label>
                                    <DropDown items={templateDropDownItems} placeHolder={"انتخاب کنید"}/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">utm - medium</label>
                                    <input type="text" name="" id="" className="Campaign-Input"
                                           placeholder="انتخاب کنید"/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">utm - campaign</label>
                                    <input type="text" name="" id="" className="Campaign-Input"
                                           placeholder="انتخاب کنید"/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">utm - term</label>
                                    <DropDown items={utmTermDropDownItems} placeHolder={"انتخاب کنید"}/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">utm - content</label>
                                    <DropDown items={utmContentDropDownItems} placeHolder={"نام نمایش دهنده"}/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">utm - source</label>
                                    <input type="text" name="" id="" className="Campaign-Input" placeholder="teejar"/>
                                </div>
                            </>
                            :
                            null
                    }
                </div>
                <Button className="d-block mx-auto px-5" type={"primary"} action={() => {
                    setChecked(showContent);
                    setOpenPopup(false);
                }} responsive={true}>تایید</Button>
            </Popup>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12 mb-3 d-flex align-items-start justify-content-start">
                    <SingleSelectDropzone title={"فایل پیشنهادی"}/>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <Comment profile={require("../../../../../../../../assets/images/avatars/Avatar7.png")}
                             name={"vidomovoe"}
                             body={"این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند"}
                             view={"3.2k"} time={"16 : 30"}/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-3 pb-1">لینک</h6>
                    <input type="text" name="" id="" className="Campaign-Input"
                           placeholder="مثال: کمپین روز مادر"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12"></div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-2 pb-1">متن کامل تبلیغ ( همراه با آدرس کانال )</h6>
                    <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                              rows={4}></textarea>
                </div>
                <div className="col-lg-6 col-md-6 col-12"></div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-2 pb-1">توضیحات بیشتر</h6>
                    <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                              rows={4}></textarea>
                    <Button className="d-block w-100 mt-4" type={"secondary"} action={() => {
                        setOpenPopup(true);
                    }} responsive={true}>
                        مدیریت utm لینک
                    </Button>
                </div>
                <div className="col-lg-6 col-md-6 col-12"></div>
            </div>
        </div>
    );
}

export default Tab3;